import SoftBadge from "components/SoftBadge";

import { getSiteStatusKey, type ProviderSiteStatus } from "./provider-site";
import { useSiteTranslations } from "./use-site-translations";

const STATUS_COLORS = {
  create: "secondary",
  draft: "warning",
  published: "success",
  disabled: "secondary",
} as const;

// The site's state in one word, which the app shows next to "Мій сайт" in the Profile menu.
export function SiteStatusBadge({ site }: { site: { status: ProviderSiteStatus } | null }) {
  const { t } = useSiteTranslations();
  const key = getSiteStatusKey(site);
  return (
    <SoftBadge
      variant="contained"
      color={STATUS_COLORS[key]}
      size="sm"
      container
      badgeContent={t.status[key]}
      data-testid="provider-site-status-badge"
    />
  );
}
